import React from 'react';

// Shared components
import { BasicDonationForm } from './';
import { ChristmasDonationSummary } from './components/Summaries';

export const ChristmasDonationForm = (props) => {
  const { values, formContent } = props;

  const SummaryComponent = (innerProps) => {
    return (
      <ChristmasDonationSummary
        part={values.partOptions.currentPart}
        area={innerProps.area}
        donationImage={formContent.donationImage}
        price={values.productOptions.product.price}
        infoText={formContent.infoText}
        heading1={formContent.sideHeading1}
        heading2={formContent.sideHeading2}
      />
    );
  };

  return <BasicDonationForm summaryComponent={SummaryComponent} {...props} />;
};
